import { Save } from '@mui/icons-material';
import {
  Box,
  Chip,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
type IProps = {
  tags: string[];
  setTags: (a: string[]) => void;
};
function Tags({ tags, setTags }: IProps) {
  const t = useTranslate();
  const [tag, setTag] = useState<string>('');

  const addTag = () => {
    setTag('');
    setTags([...tags, tag]);
  };
  const removeTag = (tg: string) => {
    setTags(tags.filter((c) => c !== tg));
  };

  return (
    <Paper sx={{ padding: 2, marginTop: 2 }}>
      <Typography variant='subtitle1'>{t('tags')}</Typography>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          margin: 1,
        }}
      >
        <TextField
          variant='outlined'
          value={tag}
          onChange={(e) => setTag(e.target.value)}
        />
        <IconButton onClick={() => addTag()}>
          <Save color='primary' />
        </IconButton>
      </Box>
      <Box sx={{ minHeight: 75 }}>
        {tags?.map((tg) => (
          <Chip
            sx={{ padding: 1, margin: 1 }}
            color='info'
            label={tg}
            key={tg}
            onDelete={() => removeTag(tg)}
          />
        ))}
      </Box>
    </Paper>
  );
}

export default Tags;
